import React from 'react';
import LoadingSvg from "../icons/loading";
import classNames from "classnames";
import styles from './style.module.css';

interface Props {
  color?: string;
}

const Spinner = (props: Props) => {
  const { color } = props;
  return (
    <div className={classNames(styles.spinner, styles.spin)}>
      <LoadingSvg color={color}/>
    </div>
  );
};

export default Spinner;